export default {"src":"/_next/static/media/no-tickets.4ff008d3.svg","height":206,"width":400,"blurWidth":0,"blurHeight":0};